import { render } from "./TeamContent.vue?vue&type=template&id=54cacbdc&ts=true"
import script from "./TeamContent.vue?vue&type=script&lang=ts"
export * from "./TeamContent.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__